import React from "react";
import { useState } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { changePassAdmin } from "../../store/actions";

import { PASS_REGEX } from "../../Services/URLS";

const ResetPassword = ({ setFieldTab }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPass1, setShowPass1] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const [state, setState] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [mainError, setMainError] = useState("");
  const email = useSelector((s) => s?.login?.userEmail);
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name == "newPassword" && !PASS_REGEX.test(value)) {
      setMainError(
        "password should be at least 8 characters, one uppercase, lowercase, special character (@,-,~,_), numeric value."
      );
    } else {
      setMainError("");
    }

    if (name == "confirmPassword") {
      if (value !== state.newPassword) {
        setError("Confirm Password should match with new password");
      } else {
        setError("");
      }
    }
    setState((pre) => ({ ...pre, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const callBack = (res) => {
      if (res.status == 200) {
        toast.success("Password Reset Successfully!");
        navigate("/customers");
      } else {
        toast.error(res.error);
      }
    };
    dispatch(
      changePassAdmin(
        { email: email, new_password: state.newPassword },
        callBack
      )
    );
  };

  return (
    <Row>
      <Col lg="12" className="my-2">
        <div className="edit-pass d-flex align-items-center">
          <label className="m-0 form-label2 m-0 me-3"> New Password</label>
        </div>
        <div className={"icon-with-div pass position-relative"}>
          <a
            onClick={() => setShowPass1(!showPass1)}
            className="icon-wrp2 position-absolute"
          >
            {showPass1 == false ? (
              <svg
                className="MuiSvgIcon-root"
                focusable="false"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path>
              </svg>
            ) : (
              <svg
                className="MuiSvgIcon-root"
                focusable="false"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fill="none"
                  d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
                ></path>
                <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"></path>
              </svg>
            )}
          </a>

          <Form.Control
            type={showPass1 == false ? "password" : "text"}
            name="newPassword"
            value={state?.newPassword}
            onChange={handleChange}
            placeholder=""
          />
        </div>
        <span className="error-span">{mainError}</span>
      </Col>
      <Col lg="12" className="my-2">
        <div className="edit-pass d-flex align-items-center">
          <label className="m-0 form-label2 m-0 me-3"> Confirm Password</label>
        </div>
        <div className={"icon-with-div pass position-relative"}>
          <a
            onClick={() => setShowPass2(!showPass2)}
            className="icon-wrp2 position-absolute"
          >
            {showPass2 == false ? (
              <svg
                className="MuiSvgIcon-root"
                focusable="false"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path>
              </svg>
            ) : (
              <svg
                className="MuiSvgIcon-root"
                focusable="false"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fill="none"
                  d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
                ></path>
                <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"></path>
              </svg>
            )}
          </a>

          <Form.Control
            type={showPass2 == false ? "password" : "text"}
            name="confirmPassword"
            value={state?.confirmPassword}
            onChange={handleChange}
            placeholder=""
          />
        </div>
        <span className="error-span">{error}</span>
      </Col>
      <Col lg="12" className="my-2">
        <div className="pt-4 btn-wrp d-flex algign-items-center">
          <Button
            className="d-flex align-items-center justify-content-center me-2"
            onClick={handleSubmit}
            disabled={
              state.newPassword !== "" &&
              state.newPassword == state.confirmPassword
                ? false
                : true
            }
          >
            Submit
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default ResetPassword;
